import { Inject, Injectable } from '@angular/core';

import { OnAppInit } from '@frontend/vanilla/core';
import { ON_POKER_APP_INIT } from '@pokercore/module';

@Injectable({ providedIn: 'root' })
export class PokerAppLazyBootstrapService {
    private isAlreadyBootstrapped = false;

    // Note: we’ve changed the type to `any[]` since each entry comes in as an object
    constructor(@Inject(ON_POKER_APP_INIT) private initializers: any[]) {}

    async onPokerAppInit(): Promise<void> {
        if (this.isAlreadyBootstrapped) {
            return;
        }

        const promises: Promise<any>[] = [];

        // each `initializerObj` looks like { someServiceName: serviceInstance }
        for (const initializerObj of this.initializers) {
            // grab the actual service instances out of the object’s values
            for (const serviceInstance of Object.values(initializerObj) as OnAppInit[]) {
                const result = serviceInstance.onAppInit();
                if (result instanceof Promise) {
                    promises.push(result);
                }
            }
        }

        await Promise.all(promises);
        this.isAlreadyBootstrapped = true;
    }
}
